<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('mina')">Orden de Despacho</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Agregar
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          
          <select-input v-model="form.maquinaria_id" :error="form.errors.maquinaria_id" class="pr-6 pb-8 w-full lg:w-1/3" label="Maquinaria/Vehiculo" required>
            <option v-for="maquinaria in maquinarias" :key="maquinaria.id" :value="maquinaria.id">{{ maquinaria.codigo }} - {{ maquinaria.clase}} - {{maquinaria.placas}}</option>
        </select-input>
        <select-input v-model="form.operador" :error="form.errors.operador" class="pr-6 pb-8 w-full lg:w-1/3" label="Operador" required>
            <option v-for="conductor in conductores" :key="conductor.id">{{ conductor.nombres }} {{ conductor.apellidos }}</option>
        </select-input>
        <select-input v-model="form.proyecto" :error="form.errors.proyecto" class="pr-6 pb-8 w-full lg:w-1/3" label="Destino de Proyecto" required>
            <option v-for="proyecto in proyectos" :key="proyecto.id">{{ proyecto.nombre}}</option>
        </select-input>
        <select-input v-model="form.material" :error="form.errors.material" class="pr-6 pb-8 w-full lg:w-2/6" label="Tipo de Material" required>
            <option>Tubos de 1200</option>
            <option>Tubos de 1000</option>
            <option>Tubos de 600</option>
            <option>OLLAS</option>
            <option>BLOQUES</option>
            <option>ARENA AZUL LAVADA</option>
            <option>ARENA AMARILLA</option>
            <option>BASE TRITURADA CLASE 1</option>
            <option>LASTRE</option>
            <option>PIEDRA BOLA +30 cm</option>
            <option>PIEDRA GRANDE/ESCOLLERA</option>
            <option>POLVO DE PIEDRA</option>
            <option>RIPO DE 1"</option>
            <option>RIPIO DE 3/4</option>
            <option>RIPIO DE 3/8</option>
            <option>SUBBASE CLASE 3</option>
            <option>GRAVILLA 3/8</option>
        </select-input>
        <text-input v-model="form.capacidad" :error="form.errors.capacidad" class="pr-6 pb-8 w-full lg:w-1/6" label="Capacidad M3" required/>
        <select-input v-model="form.proveedor" :error="form.errors.proveedor" class="pr-6 pb-8 w-full lg:w-2/6" label="Proveedor" required>
            <option>GUADALUPE</option>
            <option>COPETO</option>
            <option>SUNTRACT S.A.</option>
            <option>EUFRATES</option>
            <option>MINA 3F</option>
            <option>MINA ELOY</option>
            <option>MINA FL</option>
            <option>MINA ZIMRAN</option>
            <option>MINA LA MEJOR</option>
            <option>MINA LAS MARIAS</option>
            <option>MINA RIVERAS DEL TOACHI</option>
        </select-input>
        <text-input v-model="form.cantidad" :error="form.errors.cantidad" class="pr-6 pb-8 w-full lg:w-1/6" label="Nº de Despachos" />
        <text-input v-model="form.observaciones" :error="form.errors.observaciones" class="pr-6 pb-8 w-full lg:w-1/1" label="Observación" />

          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Agregar Orden Despacho</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from 'vuejs-datetimepicker'

export default {
  metaInfo: { title: 'Add Orden Despacho' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
     Datepicker
  },
  layout: Layout,
  props: {
    maquinarias: Array,
    proyectos: Array,
    conductores: Array,


  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        maquinaria_id: null,
        proyecto: null,
        cantidad: null,
        operador: null,
        material: null,
        observaciones: null,
        capacidad: null,
        proveedor: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('ordenes.store'))
    },
  },
}
</script>
